import React from 'react'
import { Form, Field } from 'redux-form'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import { useGetPhoneSystemHuntGroupsQuery } from 'src/generated/graphql'
import { vMin, vRequired } from 'components/Input/Input.validations'
import SelectPretty from 'components/Input/SelectPretty'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import { Input } from 'components/Input/Input'

const vMin5 = vMin(5)

export const HuntGroupFormComponent = props => {
  const {
    handleSubmit,
    className,
    onSubmit,
    node,
    nodeInfo,
    flow,
    formData,
    showPhoneSystemHuntGroupEditFormModal,
  } = props
  const submit = data => onSubmit(node, { extras: data })

  const phoneSystemHuntGroups = useGetPhoneSystemHuntGroupsQuery({
    variables: {
      phoneSystemId: flow.phoneSystemId,
    },
  })

  const options =
    phoneSystemHuntGroups.data?.phoneSystemHuntGroups.map(item => ({
      name: item.customerReference,
      value: item.id,
    })) || []

  const huntGroupInfo = phoneSystemHuntGroups.data?.phoneSystemHuntGroups.find(
    item => item.id === formData.huntGroupId
  )

  return (
    <Form onSubmit={handleSubmit(submit)} className={className}>
      <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
        Forward the call to a hunt group.{' '}
        <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
          {' '}
          Learn more.
        </a>
      </div>

      <div style={{ position: 'relative' }}>
        <Field
          label="Hunt Group"
          name="huntGroupId"
          component={SelectPretty}
          options={options}
          validate={[vRequired]}
        />
        {huntGroupInfo && (
          <Button
            size="xs"
            style={{ color: 'white', marginLeft: '5px' }}
            color="tertiary"
            onClick={async () => {
              await showPhoneSystemHuntGroupEditFormModal({
                phoneSystemId: flow.phoneSystemId,
                huntGroupId: huntGroupInfo.id,
                number: huntGroupInfo.number,
                name: huntGroupInfo.customerReference || '',
                extensionIds: huntGroupInfo.extensionIds,
              })
            }}
          >
            Edit Hunt Group
          </Button>
        )}

        <Field
          label="Timeout"
          name="timeout"
          parse={value => Number(value)}
          component={Input}
          type="number"
          info="How long before the call is marked as 'not answered'. 15 seconds is a good value if you want to use voicemail."
          validate={[vRequired, vMin5]}
        />

        {phoneSystemHuntGroups.loading && <LoadingOverlay />}
      </div>

      <div className={sLay.flex} />
      <div className={cn(sLay['layout-column'])}>
        <Button type="submit" color="tertiary" rect>
          Save Node
        </Button>
      </div>
    </Form>
  )
}



// WEBPACK FOOTER //
// src/features/Flows/Flow/Nodes/HuntGroup/HuntGroupForm.tsx